const getMissingDocumentsStatus = {
  true: 'FALTAN LOS SIGUIENTES DOCUMENTOS DEL EMPLEADO: ',
  false: 'FALTAN LOS SIGUIENTES DOCUMENTOS DE LA COMPAÑÍA: '
};

export default getMissingDocumentsStatus;
